import { render, staticRenderFns } from "./FlowServiceInfo.vue?vue&type=template&id=ff7f5afe&scoped=true"
import script from "./FlowServiceInfo.vue?vue&type=script&lang=js"
export * from "./FlowServiceInfo.vue?vue&type=script&lang=js"
import style0 from "./FlowServiceInfo.vue?vue&type=style&index=0&id=ff7f5afe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7f5afe",
  null
  
)

export default component.exports